<!-- Enrollment Errors Modal-->
<button type="button" class="btn btn-primary" id="{{modalOpenButtonId}}" [hidden]="true" data-toggle="modal"
  [attr.data-target]="'#' + modalId" data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden
  Btn</button>

<div class="modal" id="{{modalId}}" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="{{modalId}}EnrollmentErrorTitle"><i class="fa fa-exclamation-circle maroon" aria-hidden="true"></i>&nbsp;{{modalHeader}}</h5>
        <button type="button" id="{{modalCloseButtonId}}" (click)="onCancel()" class="close" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12 mb-3 table-responsive no-gutters">
            <table class="table table-striped tbl-scrollable">
              <thead class="thead-light">
                <tr>
                  <th scope="col" width="35%">VIN</th>
                  <th scope="col" width="65%">Error</th>
                </tr>
              </thead>
              <tbody *ngIf="enrollmentErrors && enrollmentErrors.length>0;"
                class="scroll-height-screenHeight hide-x-scroll">
                <tr *ngFor="let enrollmentError of enrollmentErrors; let i = index">
                  <td scope="row" width="35%">{{enrollmentError.vin}}</td>
                  <td scope="row" width="65%">{{enrollmentError.error}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal" (click)="onCancel()">CANCEL</button>
      </div>
    </div>
  </div>
</div>